















import { Component, Prop, Vue } from 'vue-property-decorator';
import  {CommentInfo}  from '@/store/models/Comment/CommentInfo';
import * as letterPossessionCommentService from '@/store/Services/letterPossessionCommentService';
import * as util from '@/util/utils.ts';
import store from '@/store';

@Component
export default class SingleLetterPossessionComment extends Vue {
    CommentInfo = {} as any;
    @Prop() comment?: '';
    @Prop() possessionId? : '';
    @Prop() id?: '';
    @Prop() commentOwnerId?: '';
    @Prop() smsAlertTime?: Date;
    @Prop() dateTime?: Date;
    loading=false;
    async deleteComment(){
        console.log(this.comment)
        if(this.comment==undefined)return;
        if(this.possessionId==undefined)return;
        // if(this.smsAlertTime==undefined)return;
        if(this.id==undefined)return;
        if(this.dateTime==undefined)return;
        if(this.commentOwnerId==undefined)return;
        this.loading=true;
        const result=await letterPossessionCommentService.DeleteComment(this.comment,this.possessionId,this.id,this.dateTime,this.commentOwnerId,this.smsAlertTime);
        this.loading=false;
        store.state.eventHub.$emit('readComments')

        }
        async editComment(){
            if(this.id==undefined)return;
            const result=await letterPossessionCommentService.ReadSingleComment(this.id);
            this.$emit('edit-Comment',result)
    }
}
